
import type { RoleAssignmentDTO } from '@empathyco/playboard-core-domain'
import type { Component, PropType } from 'vue'
import type { RoleAssignmentMessages } from '../../models'
import type { RoleAssignmentAnyConditionOption } from './role-assignment-any-condition.component.vue'
import { computed, defineComponent } from 'vue'
import { useConditionValues } from '../../composables/users/use-condition-values'
import { useRoles } from '../../composables/users/use-roles'
import { ArrayUtils } from '../../utils/array.utils'
import RoleAssignmentAnyCondition from './role-assignment-any-condition.component.vue'
import RoleAssignmentInstanceCondition from './role-assignment-instance-condition.component.vue'

export default defineComponent({
  name: 'RoleAssignmentCondition',
  components: {
    RoleAssignmentAnyCondition,
    RoleAssignmentInstanceCondition,
  },
  props: {
    value: {
      type: Object as PropType<RoleAssignmentDTO['conditions'][0]>,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    messages: {
      type: Object as PropType<RoleAssignmentMessages['conditions']>,
      required: true,
    },
  },
  emits: {
    input: (value: RoleAssignmentDTO['conditions'][0]) => {},
  },
  setup(props) {
    const { getConditionValues } = useConditionValues()
    const {
      data: { list: rolesData },
    } = useRoles()

    const baseClass = 'epb-role-assignment-condition'

    const component = computed(() => {
      let result: Component
      switch (props.value.condition) {
        case 'instance':
          result = RoleAssignmentInstanceCondition
          break
        default:
          result = RoleAssignmentAnyCondition
          break
      }
      return result
    })

    const options = computed(() => {
      let result: Array<RoleAssignmentAnyConditionOption> | undefined
      const conditionValues = getConditionValues(props.value.condition)?.filter(
        conditionValue => conditionValue !== '*',
      )
      switch (props.value.condition) {
        case 'role-id':
          result = conditionValues
            ?.map(conditionValue => ({
              value: conditionValue,
              label: rolesData.value?.results.find(role => role.id === Number(conditionValue))
                ?.name,
            }))
            .sort(ArrayUtils.sortBy('label'))
          break
        default:
          result = conditionValues
            ?.map(conditionValue => ({
              value: conditionValue,
            }))
            .sort(ArrayUtils.sortBy('value'))
          break
      }
      return result
    })

    const allowSelectAll = computed(() => getConditionValues(props.value.condition)?.includes('*'))

    return {
      baseClass,
      component,
      options,
      allowSelectAll,
    }
  },
})
